import { render } from "./HermesMySettings.vue?vue&type=template&id=45b3a586&scoped=true"
import script from "./HermesMySettings.vue?vue&type=script&lang=js"
export * from "./HermesMySettings.vue?vue&type=script&lang=js"

import "./HermesMySettings.vue?vue&type=style&index=0&id=45b3a586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b3a586"]])

export default __exports__